import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Después de mi sesión con Vanii, sentí una paz que no había experimentado en años. Me ayudó a entender cosas que llevaba arrastrando toda la vida.',
  name: 'María L.',
  service: 'Mediumnidad'
}, {
  quote: 'Los Registros Akáshicos cambiaron mi forma de ver la vida. Vanii tiene un don único para transmitir los mensajes con claridad y amor.',
  name: 'Ana R.',
  service: 'Registros Akáshicos'
}, {
  quote: 'Llegué perdida y sin rumbo. Hoy, gracias a la terapia transpersonal, me siento conectada conmigo misma y con mi propósito.',
  name: 'Laura S.',
  service: 'Terapia Transpersonal'
}];
export function Testimonials() {
  return <section id="testimonios" className="py-24 relative overflow-hidden" data-id="element-297">
      {/* Soft background image */}
      <div className="absolute inset-0 z-0" data-id="element-298">
        <img src="https://cdn.magicpatterns.com/uploads/fbQ74FsC3s2dT3V3tvS8GU/2.png" alt="" className="w-full h-full object-cover object-right" aria-hidden="true" data-id="element-299" />
        <div className="absolute inset-0 bg-white/[0.74]" data-id="element-300" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-301">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-302">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-serif text-stone-900 mb-4" data-id="element-303">
            Lo que dicen quienes ya han vivido la{' '}
            <span className="text-violet-600 italic" data-id="element-304">experiencia</span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-305">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className="bg-white p-8 rounded-2xl shadow-sm relative" data-id="element-306">
              <Quote className="absolute top-6 right-6 text-violet-100 w-12 h-12 rotate-180" data-id="element-307" />

              <div className="relative z-10" data-id="element-308">
                <p className="text-stone-600 font-light leading-relaxed mb-8 italic text-lg" data-id="element-309">
                  "{testimonial.quote}"
                </p>

                <div className="border-t border-stone-100 pt-4" data-id="element-310">
                  <p className="font-serif font-semibold text-stone-900 text-lg" data-id="element-311">
                    {testimonial.name}
                  </p>
                  <p className="text-violet-600 text-sm font-medium" data-id="element-312">
                    {testimonial.service}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}